import { Button, Stack, Typography } from '@mui/material';

import { casesQueryKey, getLatestCaseApi } from 'api/cases/query';
import routes from 'app.routes';
import { latestCasesColumns } from 'components/v2/division/column/casesColumns';
import DataGridTable from 'components/v2/table/DataGridTable';
import useAppNavigation from 'hooks/general/useAppNavigation';
import { useLocalization } from 'localization';
import { useNavigate } from 'react-router-dom';

const DashboardLatestOrders = () => {
  const { t } = useLocalization();
  const { navigateTo } = useAppNavigation();
  const { data, isLoading, isError } = getLatestCaseApi();
  const navigate = useNavigate();

  return (
    <Stack gap={1.5} sx={{ margin: '2.5rem 0' }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h4">{t('dashboard.cases.latest')}</Typography>
        <Button
          variant="outlined"
          onClick={() => navigateTo(routes.v2.cases.overview)}
          sx={{ minWidth: 'fit-content' }}
        >
          {t('dashboard.cases.viewAllCases')}
        </Button>
      </Stack>
      <DataGridTable
        rows={data?.slice(0, 5) ?? []}
        columns={latestCasesColumns()}
        loading={isLoading}
        isHideFooter
        isError={isError}
        queryKey={[casesQueryKey.latestCases()]}
        sx={{ minHeight: '12rem' }}
        onRowClick={params => {
          const record = params.row;
          navigate(`${routes.v2.cases.overview}/${record.id}`);
        }}
      />
    </Stack>
  );
};

export default DashboardLatestOrders;
